import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    employees: [],
    employeesCount: 0,
    employee: {},
    employeeSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getEmployees(state) {
      return state.employees
    },
    getEmployeesCount(state) {
      return state.employeesCount
    },
    getEmployee(state) {
      return state.employee
    },
    getEmployeeSaveStatus(state) {
      return state.employeeSave
    },
  },
  mutations: {
    EMPLOYEES_LIST(state, data) {
      state.employees = data
    },
    EMPLOYEE_VIEW(state, data) {
      state.employee = data
    },
    EMPLOYEES_COUNT(state, data) {
      state.employeesCount = data
    },
    EMPLOYEE_SAVE(state, data) {
      state.employeeSave = data
    },
  },
  actions: {
    employeesList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hr/employees', data)
        .then(response => {
          commit('EMPLOYEES_LIST', response.data.data)
          commit('EMPLOYEES_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    employeeView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'employees.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hr/employees', data)
        .then(response => {
          commit('EMPLOYEE_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    employeeSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hr/employees/saveData', data)
        .then(response => {
          commit('EMPLOYEE_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
